import { AppConstants } from '../app-constants.service';
import { BehaviorSubject, interval, Observable, Subscription } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LogoutTimer {

    private readonly DEFAULT_MAX_MINUTES_BEFORE_LOGOUT = 20;
    private MAX_MINUTES_BEFORE_LOGOUT = this.DEFAULT_MAX_MINUTES_BEFORE_LOGOUT;

    private minutesBeforeLogoutSubject: BehaviorSubject<number>= new BehaviorSubject(this.MAX_MINUTES_BEFORE_LOGOUT);
    public minutesBeforeLogoutObservable: Observable<number> = this.minutesBeforeLogoutSubject.asObservable();

    private timeoutSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public timeoutObservable: Observable<boolean> = this.timeoutSubject.asObservable();

    private keyupListener: any;
    private clickListener: any;
    private timerObservable: Observable<number>;
    private timerSubscription: Subscription;

    constructor(
        private appConstants: AppConstants
    ) {
        this.MAX_MINUTES_BEFORE_LOGOUT = Math.round(this.appConstants.tokenValidMillis / 60000);
    }

    start() {
        this.reset()

        if (!this.keyupListener) {
            this.keyupListener = window.addEventListener('keyup', () => {
                this.reset();
            });
        }

        if (!this.clickListener) {
            this.clickListener = window.addEventListener('click', () => {
                this.reset();
            });
        }

        this.timerObservable = interval(60 * 1000); // every minute
        this.timerSubscription = this.timerObservable.subscribe(() => {
            let minutesBeforeLogout = this.minutesBeforeLogoutSubject.getValue();
            this.minutesBeforeLogoutSubject.next(--minutesBeforeLogout)
        });

        this.minutesBeforeLogoutSubject.subscribe(
            minutesBeforeLogout => this.checkTimeout(minutesBeforeLogout)
        );
    }

    stop() {
        this.timerSubscription.unsubscribe();
        window.removeEventListener('keyup', this.keyupListener);
        window.removeEventListener('click', this.clickListener);
        this.keyupListener = null;
        this.clickListener = null;
    }

    checkTimeout(minutesBeforeLogout: number) {
        if (minutesBeforeLogout < 1) {
            this.timeoutSubject.next(true);
            this.stop()
        }
    }

    reset() {
        this.minutesBeforeLogoutSubject.next(this.MAX_MINUTES_BEFORE_LOGOUT)
        this.timeoutSubject.next(false);
    }

}
